import React from "react";
import { styled } from "styled-components";

const TruncatedText = ({ text, sentences, onClick, expanded }) => {

  const sentenceArray = text?.split(/[.!?]/);
  const truncatedText = sentenceArray?.slice(0, sentences).join(". ");
  return (
    <TruncatedWrapper onClick={onClick}>{!expanded ? truncatedText+'...' : text}</TruncatedWrapper>
  );
};

const TruncatedWrapper = styled.div`
  @media only screen and (min-width: 1024px) {
    display: none;
  }
  @media only screen and (max-width: 1024px) {
    font-size: 1rem;
    font-weight: 400;
    text-align: justify;
  }
`;

export default TruncatedText;
